import { Component, Input } from '@angular/core';
import { IxBaseLookupComponent, IxNgHtmlStaticUtils } from 'ix-ng-components';
import { Language } from 'projects/vpo-shared/src/vpoglednik/vpoglednik.enum';
import { UkrepLookupDTO } from './ukrep-lookup.model';

@Component({
  selector: 'lib-ukrep-lookup',
  template: `
    <header class="{{ this.lookupClass }}">
      <div class="lookup-header flex-wrap">
        @if (!IxNgHtmlStaticUtils.mobile) {
          <div class="md:col-1 sm:col-0" style="word-break:break-word;">
            {{ this.language === Language.EN ? 'Code' : 'Koda' }}
          </div>
          <div class="md:col-5 sm:col-0" style="word-break:break-word; margin-right: -6px">
            {{
              this.language === Language.EN
                ? 'Name of Measure/Intervention Chapter'
                : 'Naziv poglavja ukrepa'
            }}
          </div>
        }
        <div class="md:col-1 sm:col-3 col-3" style="word-break:break-word;">
          {{ this.language === Language.EN ? 'Code' : 'Koda' }}
        </div>
        <div class="md:col-5 sm:col-9 col-9" style="word-break:break-word;">
          {{ this.language === Language.EN ? 'Name of Measure/Intervention' : 'Naziv ukrepa' }}
        </div>
      </div>
    </header>
    @if (!this.header) {
      <div class="lookup-body flex-wrap">
        @if (!IxNgHtmlStaticUtils.mobile) {
          <div class="md:col-1 sm:col-0" style="word-break:break-word;">
            {{ item.poglavjeKoda }}
          </div>
          <div class="md:col-5 sm:col-0" style="word-break:break-word;">
            {{ this.language === Language.EN ? item.poglavjeNazivAng : item.poglavjeNaziv }}
          </div>
        }
        <div class="md:col-1 sm:col-3 col-3" style="word-break:break-word;">
          {{ item.koda }}
        </div>
        <div class="md:col-5 sm:col-9 col-9" style="word-break:break-word;">
          {{ this.language === Language.EN ? item.nazivAng : item.naziv }}
        </div>
      </div>
    }
  `,
})
export class UkrepLookupComponent extends IxBaseLookupComponent {
  @Input()
  override item!: UkrepLookupDTO;
  @Input()
  public language?: Language;
  @Input()
  public sifraHeader?: string;
  protected readonly Language = Language;
  protected readonly IxNgHtmlStaticUtils = IxNgHtmlStaticUtils;
}
